// META VALUES
export const META_KEYWORDS =
  'cheap flights, cheap tickets, flight tickets, airlines tickets, air tickets, plane tickets, cheap airfare'
export const META_DESCRIPTION =
  'Book cheap flights & save big at AirTkt.com. Choose from 370+ airlines and 1000s of destinations. Amazing flight deals on domestic and international travel.'
export const DOCUMENT_TITLE =
  'AirTkt: Cheap Airline Tickets, Hotels & Car Rentals'

// API AUTHENTICATION
export const USERNAME = 'satish.garg@svgmedia.in'
export const PASSWORD = `9971041564`

// CALL FORM MESSAGES
export const CALL_FORM_SUCCESS =
  'Thank you for submitting a request.<br />One of our specialists will contact you shortly. '
export const MODAL_CALL_FORM_SUCCESS =
  'Thank you for submitting a group request.<br />One of our specialists will contact you shortly.'
export const CALL_FORM_ERROR = 'Some error occured. Please try after some time.'

// ERROR MESSAGES
export const NO_AIRPORT_ERROR = 'Please enter an airport.'
export const ORIGIN_DEST_SAME_ERROR =
  'Departure and arrival cities must be different.'
export const TRAVEL_DATES_ERROR =
  'Please enter depart date.**Please enter return date.'
export const DEPART_DATE_ERROR = 'Please enter depart date.'
export const RETURN_DATE_ERROR = 'Please enter return date.'
export const ZERO_PASSENGER_ERROR =
  'Please select at least 1 passenger to continue.'
export const PASSENGER_LIMIT_ERROR =
  'Booking a trip for ten or more people, click below to submit a group booking request and one of our group specialists will contact you shortly.**Alternatively, you can call us at <a href="tel:+1-800-247-4775">800-247-4775</a>.'
export const INFANT_LAP_ERROR =
  'One infant on lap allowed with one adult.**Second infant must be booked as an infant on the seat.**Infant on the seat pays the applicable fare.'
export const INFANT_SEAT_ERROR =
  'Maximum 2 infants are allowed with one adult.**Infant on the seat pays the applicable fare.'
export const CHILDREN_ERROR =
  'Please select at least 1 adult passenger or call on <a href="tel:+1-800-247-4775">800-247-4775</a> to book unaccompnied minor.'

// MISCELLANEOUS
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY'
export const FARE_TABLE_DATE_FORMAT = 'MMM DD, YYYY'
